export default __webpack_public_path__ + "static/media/This is what dating me will look like.87cb9475.mp4";